import Text from '../../shared/Text/Text';
import { formatSnippet } from './formatSnippet';
import { highlightMatches } from './highlightMatches';

const HighlightedSnippet = ({
  snippet,
  query,
}: {
  snippet: string;
  query: string;
}) => (
  <Text type="body2" color="#666" sx={{ wordBreak: 'break-word' }}>
    {highlightMatches(formatSnippet(snippet), query).map((segment, index) =>
      segment.isMatch ? (
        <mark key={index}>{segment.text}</mark>
      ) : (
        <span key={index}>{segment.text}</span>
      )
    )}
  </Text>
);

export default HighlightedSnippet;
